import type { AxiosRequestConfig } from 'axios';
import z from 'zod';
import { api } from '../../axios.instance';
import { responseContract } from '../../lib';

export const UploadUserImageRequestDtoSchema = z.object({
  file: z
    .instanceof(File)
    .refine((file) => file.size > 0, 'File is required')
    .refine((file) => file.size <= 10 * 1024 * 1024, 'File must be ≤ 1MB')
    .refine(
      (file) => ['image/png', 'image/jpeg', 'image/jpg'].includes(file.type),
      'Only PNG and JPG files are allowed'
    ),
});

const UploadUserImageResponseDtoSchema = z.object({
  imageUrl: z.string(),
});

export type UploadUserImageRequestDto = FormData;
export type UploadUserImageResponseDto = z.infer<
  typeof UploadUserImageResponseDtoSchema
>;

export const uploadUserImage = (
  dto: UploadUserImageRequestDto,
  config?: AxiosRequestConfig
) => {
  return api
    .post('/users/image/upload', dto, config)
    .then(responseContract(UploadUserImageResponseDtoSchema));
};
